import type { Plan } from '@cognitoforms/types/server-types/plans/model/plan';
import type { PricingTier } from '@cognitoforms/types/server-types/plans/model/pricing-tier';

export const allPlans = ['Individual', 'Pro', 'Team', 'Business', 'Enterprise'] as const;
export type PlanLevelName = (typeof allPlans)[number];

export function getVariantPlan(pricingTier: PricingTier, plan: PlanLevelName): Plan {
	return pricingTier[plan]!;
}

const advertisedAnnualSavingsPercent: Record<string, number> = {
	JUL2026: 25,
	NPJUL2026: 25,
	SEP2026BIZEXP: 30
};

/**
 * The savings percent advertised for choosing an annual term, for "Up to N% off" copy.
 * Listed per tier code where the advertised number is an editorial choice rather than the
 * arithmetic; any other tier falls back to the largest savings its plans actually offer off
 * their monthly rate, and 0 when no plan offers an annual rate.
 */
export function getAnnualSavingsPercent(pricingTier: PricingTier | null | undefined): number {
	if (!pricingTier)
		return 0;

	const advertised = advertisedAnnualSavingsPercent[pricingTier.Code];
	if (advertised)
		return advertised;

	let maxSavings = 0;
	for (const name of allPlans) {
		const plan = pricingTier[name];
		if (!plan || !plan.AnnualMonthlyAmount || plan.MonthlyAmount <= 0)
			continue;

		maxSavings = Math.max(maxSavings, Math.round((1 - plan.AnnualMonthlyAmount / plan.MonthlyAmount) * 100));
	}

	return maxSavings;
}
